import * as React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { LinkButton } from '@cian/ui-kit/button';
import { Table16 } from '@cian/ui-kit/icons';

import { IAppState } from '../../../../common/state';
import { withEmptyRendering } from '../../../../utils/hoc/withEmptyRendering';
import { SummaryButtonWrapper } from '../../../components/Summary';
import { trackTableViewButtonClicked } from '../utils/tracking';
import { isRedesignExperimentEnabled } from '../../../../selectors/isRedesignExperimentEnabled';

export interface ITableViewButtonProps {
  href: string;
  tableViewAllowed: boolean;
  isRedesignEnabled: boolean;
}

export function TableViewButton({ isRedesignEnabled, href }: ITableViewButtonProps) {
  return (
    <SummaryButtonWrapper>
      <LinkButton
        href={href}
        size="XS"
        theme={isRedesignEnabled ? 'fill_white_primary' : 'fill_secondary'}
        beforeIcon={<Table16 color="primary_100" />}
        onClick={trackTableViewButtonClicked}
      >
        Таблицей
      </LinkButton>
    </SummaryButtonWrapper>
  );
}

export function mapStateToProps(state: IAppState): ITableViewButtonProps {
  const {
    results: { queryString },
    user,
  } = state;

  const encodeQueryString = queryString ? encodeURIComponent(queryString) : '';
  const href = queryString
    ? `https://my.cian.ru/offers?from_full_url=${encodeQueryString}`
    : 'https://my.cian.ru/offers';

  return {
    href,
    isRedesignEnabled: isRedesignExperimentEnabled(state),
    tableViewAllowed: user.isAuthenticated && user.isAgent,
  };
}

export const SummaryTableViewButtonContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering((props: ITableViewButtonProps) => !props.tableViewAllowed),
)(TableViewButton);
